import React, {FunctionComponent} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import GenericModal from "./GenericModal";
import {
  OrderItemDefaultSelectable,
  OrderItemReferenceValue, OrderItemWithDefaultsRequest,
} from "../../../interfaces/OrderItemInterfaces";
import {toast} from "react-toastify";
import {orderItemService} from "../../../services/OrderItemService";

interface ModalModifyOrderItemsProps {
  open: boolean,
  onCancel: () => void,
  onValidate: () => void,
  orderItems: OrderItemDefaultSelectable[],
  referenceType: OrderItemReferenceValue,
}

const ModalModifyOrderItems: FunctionComponent<ModalModifyOrderItemsProps> = ({
  open,
  onValidate,
  onCancel,
  orderItems,
  referenceType,
}) => {
  const intl = useIntl()
  const validateButton = intl.formatMessage({id: referenceType === OrderItemReferenceValue.DESCRIPTION ? "order_items_form_validate_description" : "order_items_form_validate_price"})
  const cancelButton = intl.formatMessage({id: "cancel_button"})

  const handleSubmit = () => {
    const requestBody: OrderItemWithDefaultsRequest[] = orderItems.map(value => ({
      orderItemId: value.id,
      descriptionChanged: referenceType === OrderItemReferenceValue.DESCRIPTION,
      defaultDescription: value.referenceDescription,
      paxPriceChanged: referenceType === OrderItemReferenceValue.PRICE,
      defaultPaxPrice: value.referencePrice
    }))

    orderItemService.updateOrderItemsWithDefault(requestBody)
      .then(() => {
        toast.success(intl.formatMessage({id: "order_form_applied"}))
        onValidate()
      })
      .catch(() => toast.error(intl.formatMessage({id: "order_form_error"})))
  }

  return (
    <GenericModal
      open={open}
      className="p-3"
      title={intl.formatMessage({id: referenceType === OrderItemReferenceValue.DESCRIPTION ? "order_items_form_title_description" : "order_items_form_title_price"})}
      footer={{
        primaryAction: {
          buttonLabel: validateButton,
          action: () => handleSubmit()
        },
        secondaryAction: {
          buttonLabel: cancelButton,
          action: onCancel
        }
      }}
    >
      <div className="d-flex w-100">
        <div>
          <p className="fs-14 fw-normal"><FormattedMessage id="order_items_modify_modal_info"/></p>
          <div className="d-flex flex-column justify-content-between">
            {orderItems.map((orderItem, index) => (
              <div key={index} className="border-top py-3 w-100 d-flex flex-row">
                <span>{orderItem.name} | {orderItem.orderName}</span>
              </div>
            ))
            }
          </div>
        </div>
      </div>
    </GenericModal>
  )
}

export default ModalModifyOrderItems
